module.exports = __webpack_public_path__ + "img/thumbnail-header-15.b0c411f.jpeg";